import React from 'react'
import styled, { css } from 'styled-components'
import { giphyLightGrey, giphyDarkestGrey, giphyLightestGrey, giphyGreen } from '../../../styles/colors'

const Container = styled.div`
    position: absolute;
    bottom: -30px;
    height: 60px;
    width: 900px;

    display: flex;

    color: ${giphyDarkestGrey};
    font-weight: bold;
    font-size: 1.5rem;

    background-color: ${giphyLightestGrey};
    box-shadow: 0 2px 14px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
`

const Option = styled.a.attrs({ role: 'button', href: '#' })<{ selected: boolean }>`
    flex: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    color: ${giphyDarkestGrey};
    text-decoration: none;

    cursor: pointer;
    border: solid 1px ${giphyLightGrey};
    transition: background-color 160ms, border-color 160ms;

    &:nth-child(1) {
        border-radius: 4px 0 0 4px;
    }

    &:nth-child(2) {
        border-radius: 0 4px 4px 0;
    }

    ${props =>
        props.selected &&
        css`
            background-color: ${giphyGreen};
            border-color: ${giphyGreen};
            transition: background-color 160ms, border-color 320ms;
        `};

    > input {
        display: none;
    }
`

type Props = {
    value: 'SDK' | 'API'
    onChange: (value: 'SDK' | 'API') => void
}

const Toggle = ({ value, onChange }: Props) => {
    const onSelect = (givenValue: 'SDK' | 'API') => (e: React.SyntheticEvent) => {
        e.preventDefault()

        if (givenValue !== value) {
            onChange(givenValue)
        }
    }

    return (
        <Container>
            <Option selected={value === 'SDK'} onClick={onSelect('SDK')}>
                SDK Questions
            </Option>
            <Option selected={value === 'API'} onClick={onSelect('API')}>
                API Questions
            </Option>
        </Container>
    )
}

export default Toggle
